export const REPORT_ACTIVITY_KINDS = {
  summary: ['order', 'refund', 'charge', 'delivery', 'quote'],
  orders: ['order'],
  refunds: ['refund'],
  charges: ['charge'],
  deliveries: ['delivery'],
  pos: []
}

export const REPORT_ACTIVITY_LABELS = {
  order: 'Pedidos',
  refund: 'Devoluciones',
  charge: 'Cobros',
  delivery: 'Entregas',
  quote: 'Cotizaciones'
}

const SUMMARY_MOTIVE_KINDS = ['order', 'delivery', 'refund', 'charge']

export function getReportMotiveKinds(activeTab, availableActivities) {
  const kinds =
    activeTab === 'summary' ? SUMMARY_MOTIVE_KINDS : REPORT_ACTIVITY_KINDS[activeTab] || []
  return kinds.filter((kind) => !availableActivities || availableActivities.includes(kind))
}
